import type { SettingsForLayerCombinationFormat } from "./types";

export const ALL_SETTINGS_FOR_ALL_LAYER_COMBINATIONS = [
    {
        layerCombination: ["precipitation"],
        settings: {
            timeline: {
                timeMarkerFromLayer: "precipitation",
                showIntensityBar: true,
                nearcast: {
                    sliderCompleteRunDurationInSeconds: 35,
                    timeDisplayRoundingInMinutes: 5,
                    timeMarkerIntervalInMinutes: 30,
                    timeMarkerLinesSmallIntervalInMinutes: 5,
                    timeMarkerLinesMediumIntervalInMinutes: 30,
                    timeMarkerLinesLargeIntervalInMinutes: 60,
                    showTimeDisplayWithRange: false,
                },
                forecast: {
                    sliderCompleteRunDurationInSeconds: 30,
                    timeDisplayRoundingInMinutes: 60,
                    timeMarkerIntervalInMinutes: 240,
                    timeMarkerLinesSmallIntervalInMinutes: 60,
                    timeMarkerLinesMediumIntervalInMinutes: undefined,
                    timeMarkerLinesLargeIntervalInMinutes: 240,
                    showTimeDisplayWithRange: true,
                },
            },
            map: {
                interpolation: {
                    nearcast: true,
                    forecast: false,
                },
            },
            selectedLocationPopup: {
                layersToShowValueFrom: ["precipitation"],
                captionTranslationKey: "intensity",
            },
        },
    },
    {
        layerCombination: ["clouds"],
        settings: {
            timeline: {
                timeMarkerFromLayer: "clouds",
                showIntensityBar: false,
                nearcast: {
                    sliderCompleteRunDurationInSeconds: 35,
                    timeDisplayRoundingInMinutes: 5,
                    timeMarkerIntervalInMinutes: 30,
                    timeMarkerLinesSmallIntervalInMinutes: 5,
                    timeMarkerLinesMediumIntervalInMinutes: 30,
                    timeMarkerLinesLargeIntervalInMinutes: 60,
                    showTimeDisplayWithRange: false,
                },
                forecast: {
                    sliderCompleteRunDurationInSeconds: 30,
                    timeDisplayRoundingInMinutes: 60,
                    timeMarkerIntervalInMinutes: 240,
                    timeMarkerLinesSmallIntervalInMinutes: 60,
                    timeMarkerLinesMediumIntervalInMinutes: undefined,
                    timeMarkerLinesLargeIntervalInMinutes: 240,
                    showTimeDisplayWithRange: true,
                },
            },
            map: {
                interpolation: {
                    nearcast: true,
                    forecast: false,
                },
            },
            selectedLocationPopup: {
                layersToShowValueFrom: ["clouds"],
                captionTranslationKey: "productCategories.clouds.intensity",
            },
        },
    },
    {
        layerCombination: ["wind"],
        settings: {
            timeline: {
                timeMarkerFromLayer: "wind",
                showIntensityBar: true,
                nearcast: {
                    sliderCompleteRunDurationInSeconds: 30,
                    timeDisplayRoundingInMinutes: 60,
                    timeMarkerIntervalInMinutes: 480,
                    timeMarkerLinesSmallIntervalInMinutes: 60,
                    timeMarkerLinesMediumIntervalInMinutes: undefined,
                    timeMarkerLinesLargeIntervalInMinutes: 480,
                    showTimeDisplayWithRange: true,
                },
            },
            map: {
                interpolation: {
                    nearcast: true,
                    forecast: true,
                },
            },
            selectedLocationPopup: {
                layersToShowValueFrom: ["wind"],
                captionTranslationKey: "speed",
            },
        },
    },
    {
        layerCombination: ["windGust"],
        settings: {
            timeline: {
                timeMarkerFromLayer: "windGust",
                showIntensityBar: true,
                nearcast: {
                    sliderCompleteRunDurationInSeconds: 30,
                    timeDisplayRoundingInMinutes: 60,
                    timeMarkerIntervalInMinutes: 480,
                    timeMarkerLinesSmallIntervalInMinutes: 60,
                    timeMarkerLinesMediumIntervalInMinutes: undefined,
                    timeMarkerLinesLargeIntervalInMinutes: 480,
                    showTimeDisplayWithRange: true,
                },
            },
            map: {
                interpolation: {
                    nearcast: true,
                    forecast: true,
                },
            },
            selectedLocationPopup: {
                layersToShowValueFrom: ["windGust"],
                captionTranslationKey: "speed",
            },
        },
    },
    {
        layerCombination: ["precipitation", "clouds"],
        settings: {
            timeline: {
                timeMarkerFromLayer: "precipitation",
                showIntensityBar: true,
                nearcast: {
                    sliderCompleteRunDurationInSeconds: 35,
                    timeDisplayRoundingInMinutes: 5,
                    timeMarkerIntervalInMinutes: 30,
                    timeMarkerLinesSmallIntervalInMinutes: 5,
                    timeMarkerLinesMediumIntervalInMinutes: 30,
                    timeMarkerLinesLargeIntervalInMinutes: 60,
                    showTimeDisplayWithRange: false,
                },
                forecast: {
                    sliderCompleteRunDurationInSeconds: 30,
                    timeDisplayRoundingInMinutes: 60,
                    timeMarkerIntervalInMinutes: 240,
                    timeMarkerLinesSmallIntervalInMinutes: 60,
                    timeMarkerLinesMediumIntervalInMinutes: undefined,
                    timeMarkerLinesLargeIntervalInMinutes: 240,
                    showTimeDisplayWithRange: true,
                },
            },
            map: {
                interpolation: {
                    nearcast: true,
                    forecast: false,
                },
            },
            selectedLocationPopup: {
                layersToShowValueFrom: ["precipitation"],
                captionTranslationKey: "intensity",
            },
        },
    },
    {
        layerCombination: ["warnings"],
        settings: {
            map: {
                interpolation: {
                    nearcast: false,
                    forecast: false,
                },
            },
            selectedLocationPopup: {
                layersToShowValueFrom: ["warnings"],
                captionTranslationKey: "intensity",
            },
            timeline: {
                timeMarkerFromLayer: "precipitation",
                showIntensityBar: true,
                nearcast: {
                    sliderCompleteRunDurationInSeconds: 30,
                    timeDisplayRoundingInMinutes: 5,
                    timeMarkerIntervalInMinutes: 30,
                    timeMarkerLinesSmallIntervalInMinutes: 5,
                    timeMarkerLinesMediumIntervalInMinutes: 30,
                    timeMarkerLinesLargeIntervalInMinutes: 60,
                    showTimeDisplayWithRange: false,
                },
                forecast: {
                    sliderCompleteRunDurationInSeconds: 30,
                    timeDisplayRoundingInMinutes: 60,
                    timeMarkerIntervalInMinutes: 240,
                    timeMarkerLinesSmallIntervalInMinutes: 60,
                    timeMarkerLinesMediumIntervalInMinutes: undefined,
                    timeMarkerLinesLargeIntervalInMinutes: 240,
                    showTimeDisplayWithRange: true,
                },
            },
        },
    },
] as const satisfies SettingsForLayerCombinationFormat[];
